import { render, staticRenderFns } from "./secondMarketManagement.vue?vue&type=template&id=c69b6f56&scoped=true"
import script from "./secondMarketManagement.vue?vue&type=script&lang=js"
export * from "./secondMarketManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c69b6f56",
  null
  
)

export default component.exports